module.exports = __webpack_public_path__ + "static/media/sala-02-coworking.6c13889f.jpeg";